import React from 'react';
import PropTypes from 'prop-types';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { Form as Formsy } from 'formsy-react';
import MenuItem from 'material-ui/MenuItem';
import { CardActions } from 'material-ui/Card';

import { FormsyCheckbox as Checkbox } from 'formsy-material-ui';
import SelectField from '../Common/SelectField';
import TextField from '../Common/TextField';
import TimePicker from '../Common/TimePicker';
import moment from 'moment';


const EventDialogCreate = (props) => (
    <Dialog
        title={props.title}
        open={props.open}
        modal={false}
        onRequestClose={props.onClose}
    >
        {props.eventDates}
        <Formsy onSubmit={props.onSave}>
            {props.nameRequired && (
                <TextField
                    name='name'
                    hintText="Title"
                    validations="minLength:2,maxLength:80"
                    validationError="Must contain at least 2 characters"
                    floatingLabelText="Title"
                    required
                />
            )}

            {(!!props.locations && props.locations.length > 0) && (
                <SelectField name="locationId" floatingLabelText="Location" value={props.locationId}>
                    {props.locations.map(({ id, name }) => <MenuItem key={id} value={id} primaryText={name} />)}
                </SelectField>
            )}
            <div className='cent-flex-row cent-dialog-text' >
                <div className='cent-col-2'>
                    <TimePicker
                        name='timeStart'
                        value={new Date(props.start)}
                        floatingLabelText="Start time"
                        required
                    />
                </div>
                <div className='cent-col-2'>
                    <TimePicker
                        name='timeEnd'
                        value={new Date(props.end)}
                        floatingLabelText="End time"
                        required
                    />
                </div>
                <div className='cent-col-1'>
                    <Checkbox name="private" label="private" style={{marginTop: 16}} defaultChecked/>
                </div>
            </div>
            <CardActions className="cent-dialog-actions">
                <FlatButton key="cancel" label="Cancel" onTouchTap={props.onClose} />
                <FlatButton key="submit" label="Create" type="submit" primary={true}/>
            </CardActions>
        </Formsy>
    </Dialog>
);


const isDate = PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date), PropTypes.instanceOf(moment)]);

EventDialogCreate.propTypes = {
    title:          PropTypes.string.isRequired,
    nameRequired:   PropTypes.bool,
    open:           PropTypes.bool,
    locations:      PropTypes.arrayOf(
        PropTypes.shape({
            id:     PropTypes.number.isRequired,
            name:   PropTypes.string.isRequired
        })
    ),
    locationId:     PropTypes.number,
    eventDates:     PropTypes.string,
    start:          isDate.isRequired,
    end:            isDate.isRequired,
    onClose:        PropTypes.func,
    onSave:         PropTypes.func
};

EventDialogCreate.defaultProps = {
    title:          'New event',
    nameRequired:   true,
    eventDates:     '',
    onSave:         () => true
};

export default EventDialogCreate;
